<script setup lang="ts">
  import { Separator } from "@/components/ui/separator";
  import TargetSection from "./components/TargetSection.vue";
  import QuestionnaireSection from "./components/QuestionnaireSection.vue";
  import LinksSection from "./components/LinksSection.vue";
  import OwnersSection from "./components/OwnersSection.vue";
  import type { Histo } from "@/components/Admin/Histo/HistoDataTable/types";

  defineProps<{
    histo: Histo;
  }>();
</script>

<template>
  <div class="space-y-6">
    <TargetSection :histo="histo" />

    <Separator />

    <QuestionnaireSection :histo="histo" />

    <Separator />

    <LinksSection :histo="histo" />

    <Separator />

    <OwnersSection :histo="histo" />
  </div>
</template>
